import type { ChannelsType } from 'ChannelsTabs/types'

export const CHANGE_SUB_LIST_TYPE = 'CHANGE_SUB_LIST_TYPE'

export const channelsOptions: ChannelsType[] = ['channels', 'saleTypes', 'countries']
